module.exports = __webpack_public_path__ + "7ce6b915f0ffbd967d391822c2be7c9a.MP3";